import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchWork } from 'app/actions/WorkActions';
import { getWork } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';

export default function WorkContainer(props) {
    let dispatch = useDispatch();
    let work = useSelector(getWork);

    useEffect(() => {
        if (isEmpty(work)) fetchWorkAction();
    }, []);
    const fetchWorkAction = () => dispatch(fetchWork());

    //Filter by Contract
    work =  work.filter(e => {
        return e.idContract === props.contract;
    });

    return (props.children({ work }));

   
}